import { ReactNode } from 'react';

import { SidePaneContainer } from './TwoPaneLayout.styled';

interface SidePaneProps {
  children: ReactNode;
}

const SidePane = ({ children }: SidePaneProps) => {
  return <SidePaneContainer>{children}</SidePaneContainer>;
};

export default SidePane;
